import { inject } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import Keycloak from 'keycloak-js';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const keycloak = inject(Keycloak);

  function getImpersonationAuthRootUrl() {
    const parts = environment.impersonationCollaborationUrl.split('/');
    if (parts.length >= 4) {
      return parts.slice(0, 3).join('/');
    }
    return environment.impersonationCollaborationUrl;
  }

  const impersonationRootUrl = getImpersonationAuthRootUrl();
  if (req.url.startsWith(environment.apiUrl) || req.url.startsWith(environment.keycloakUrl) || req.url.startsWith(impersonationRootUrl)) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${keycloak.token}`),
    });
    return next(authReq);
  } else {
    return next(req);
  }
}
